import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AppSettingsComponent } from './app-settings/app-settings.component';
import { AuthGuard } from '../auth/auth.guard.service';
import { APP_SETTINGS_PATHS } from './app-settings';

const routes: Routes = [
  {
    path: APP_SETTINGS_PATHS.settings,
    component: AppSettingsComponent,
    canActivate: [AuthGuard],
    data: {
      animation: 'AppSettingsPage',
      permission: 'settings.get',
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AppSettingsRoutingModule {}
